import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { SpecificationDefinition } from '../models/product.model';

@Injectable({ providedIn: 'root' })
export class SpecificationDefinitionService {
  private readonly http = inject(HttpClient);

  getByCategory(categoryId: string): Observable<SpecificationDefinition[]> {
    return this.http.get<SpecificationDefinition[]>(
      `${API_BASE_URL}/categories/${categoryId}/specification-definitions`
    );
  }

  create(categoryId: string, name: string): Observable<SpecificationDefinition> {
    return this.http.post<SpecificationDefinition>(
      `${API_BASE_URL}/categories/${categoryId}/specification-definitions`,
      { name }
    );
  }

  update(categoryId: string, id: string, name: string): Observable<SpecificationDefinition> {
    return this.http.put<SpecificationDefinition>(
      `${API_BASE_URL}/categories/${categoryId}/specification-definitions/${id}`,
      { name }
    );
  }

  setOrder(categoryId: string, ids: string[]): Observable<void> {
    return this.http.put<void>(
      `${API_BASE_URL}/categories/${categoryId}/specification-definitions/order`,
      { ids }
    );
  }

  delete(categoryId: string, id: string): Observable<void> {
    return this.http.delete<void>(
      `${API_BASE_URL}/categories/${categoryId}/specification-definitions/${id}`
    );
  }
}
